import * as requestFromServer from "./CourseSubjectsCrud";
import { callTypes, courseSubjectSlice } from "./CourseSubjectsSlice";

const {actions} = courseSubjectSlice;

export const getCourseSubjects = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getCourseSubjects(queryParams)
    .then(response => {
      dispatch(actions.courseSubjectsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllCourseSubjects = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllCourseSubjects(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getCourseSubject = (id, courseId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewCourseSubject(courseId)
    .then(response => {
      dispatch(actions.courseSubjectFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getCourseSubject(id)
    .then(response => {
      dispatch(actions.courseSubjectFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveCourseSubject = subject => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveCourseSubject(subject)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const saveCourseSubjectAndOutcomes = subjectAndOutcomes => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveCourseSubjectAndOutcomes(subjectAndOutcomes)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteCourseSubjects = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteCourseSubjects(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanCourseSubjectsState = () => dispatch => {
  dispatch(actions.courseSubjectsStateCleaned());
}